export const chainId = 43114;
export const chainIdHex = `0x${chainId.toString(16)}`;

export const rpcUrl = "https://api.avax.network/ext/bc/C/rpc";

export const rocksAddress = "0x2Cc5C4BBfDeD4Bdc9B1aAEBd0351FEA173733a71";
